import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {MetaService} from '../services/meta.service';
import {TitleService} from '../services/title.service';
import {LanguageService} from '../services/language.service';

@Component({
    selector: 'app-mobile',
    templateUrl: './mobile.component.html',
    imports: [
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./mobile.component.scss']
})
export class MobileComponent implements OnInit {

    features = [
        {key: 'EASY', icon: 'easy.webp'},
        {key: 'DETAILLED', icon: 'detailled.webp'},
        {key: 'SETTINGS', icon: 'settings.webp'},
        {key: 'DESIGN', icon: 'design.webp'}
    ];

    appFeatures = [
        {key: '1', icon: 'recommendations.webp'},
        {key: '4', icon: 'personalize.webp'},
        {key: '2', icon: 'favorites.webp'},
        {key: '5', icon: 'print.webp'},
        {key: '3', icon: 'planner.webp'},
        {key: '6', icon: 'widget.webp'}
    ];

    constructor(
        private translate: TranslateService,
        private metaService: MetaService,
        private titleService: TitleService,
        public language: LanguageService
    ) {
    }

    getAboutImage() {
        return `assets/images/app/${this.language.current()}/about.webp`;
    }

    ngOnInit(): void {
        this.setTitleAndMeta();
    }

    private setTitleAndMeta() {
        this.translate.get('TITLE.APP').subscribe((translated: string) => {
            this.titleService.updateTitleText(this.translate, translated);
        });

        this.translate.get('META.DESCRIPTION.APP').subscribe((translated: string) => {
            this.metaService.updateDescription(translated);
            this.metaService.updateCanonicalUrl('/app');
            this.metaService.updateSocialTags(
                this.translate.instant('TITLE.APP'),
                translated,
                '/app'
            );
        });

        this.translate.get('META.KEYWORDS.APP').subscribe((translated: string) => {
            this.metaService.updateKeywords(translated);
        });
    }

}
